import Config from '../small-component'
import FormDesign from './index.vue'


const avue = {
    install(Vue) {
        Vue.use(Config);
        const name = 'hx' + FormDesign.name;
        Vue.component(name, FormDesign);
    }
}

export default avue;



// WEBPACK FOOTER //
// ./src/avue/main-component/index.js